import React,{useContext} from "react";
import money_rounding from '../../../utils/money_rounding';
import numberbeautify from '../../../utils/numberbeautify';
import show_million_format from '../../../utils/show_million_format';
import iqd_rounding from "../../../utils/iqd_rounding";
import moment from "moment/moment";
import { GlobalContext } from "../../../context/provider";

export const Statment_of_current_table_print = React.forwardRef((props, ref) => {
    const { initState } = useContext(GlobalContext);
    return (
        <div ref={ref}>
            <div className="mt-20 mx-3 p-2 flex justify-center" style={{border:'2px solid black'}}>
                شركة خندةي مال للتجارة العامة و المستلزمات المنزلية / المحدودة
            </div>
            <div className="flex justify-center underline">
                كشف العمليات الجارية للسنة المتنهية في {props?.mizania_date}/12/31
            </div>
            <div className="my-2 mx-3">
                <table className="w-full border-collapse border border-slate-800" dir="rtl">
                    <thead>
                        <tr>
                            <th className="border border-slate-800 px-0 py-2">
                                <div>رقم</div>
                                <div>الكشف</div>
                            </th>
                            <th className="border border-slate-800 px-0 py-2">
                                <div>رقم</div>
                                <div>الدليل</div>
                            </th>
                            <th className="border border-slate-800 px-0 py-2">اسم الحساب</th>
                            <th className="border border-slate-800 px-0 py-2">
                                <div>السنة الحالية</div>
                                <div>دينار/الف</div>
                            </th>
                            <th className="border border-slate-800 px-0 py-2">
                                <div>السنة السابقة</div>
                                <div>دينار/الف</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="border border-slate-800 px-1 py-1 text-center"></td>
                            <td className="border border-slate-800 px-1 py-1 text-center">421</td>
                            <td className="border border-slate-800 px-1 py-1 underline">
                                صافي مبيعات البضائع بغرض البيع
                            </td>
                            <td className="border border-slate-800 px-1 py-1 text-center">
                                {numberbeautify(show_million_format(Number(props?.total_current_sold)))}
                            </td>
                            <td className="border border-slate-800 px-1 py-1 text-center">
                                {numberbeautify(show_million_format(Number(props?.total_previous_sold)))}
                            </td>
                        </tr>
                        <tr>
                            <td className="border border-slate-800 px-1 py-1 text-center"></td>
                            <td className="border border-slate-800 px-1 py-1 text-center"></td>
                            <td className="border border-slate-800 px-1 py-1">
                                المجموع
                            </td>
                            <td className="border border-slate-800 px-1 py-1 text-center">
                                {numberbeautify(show_million_format(Number(props?.total_current_sold)))}
                            </td>
                            <td className="border border-slate-800 px-1 py-1 text-center">
                                {numberbeautify(show_million_format(Number(props?.total_previous_sold)))}
                            </td>
                        </tr>
                        <tr>
                            <td className="border border-slate-800 px-1 py-1 text-center"></td>
                            <td className="border border-slate-800 px-1 py-1 text-center"></td>
                            <td className="border border-slate-800 px-1 py-1 underline">
                                المصروفات الجارية
                            </td>
                            <td className="border border-slate-800 px-1 py-1 text-center"></td>
                            <td className="border border-slate-800 px-1 py-1 text-center"></td>
                        </tr>
                        {props?.data?.map((item, index)=>(
                            <tr key={index}>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {item?.mizania_statement_number}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {item?.mizania_directory_number}
                                </td>
                                <td className="border border-slate-800 px-1 py-1">
                                    {item?.expense_type_name}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(show_million_format(Number(item?.total_current_expense)))}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(show_million_format(Number(item?.total_previous_expense)))}
                                </td>
                            </tr>
                        ))}
                        {props?.mizania?.filter((item)=>item?.mizania_category=="المصروفات الجارية")?.map((item, index)=>(
                            <tr key={index}>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {item?.mizania_statement_number}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {item?.mizania_directory_number}
                                </td>
                                <td className="border border-slate-800 px-1 py-1">
                                    {item?.mizania_name}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(show_million_format(item?.current_amount))}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(show_million_format(item?.previous_amount))}
                                </td>
                            </tr>
                        ))}
                        <tr>
                            <td className="border border-slate-800 px-1 py-1 text-center"></td>
                            <td className="border border-slate-800 px-1 py-1 text-center">
                                35
                            </td>
                            <td className="border border-slate-800 px-1 py-1">
                                مشتريات بضائع بغرض البيع
                            </td>
                            <td className="border border-slate-800 px-1 py-1 text-center">
                                {numberbeautify(show_million_format(props?.total_current_bought))}
                            </td>
                            <td className="border border-slate-800 px-1 py-1 text-center">
                                {numberbeautify(show_million_format(props?.total_previous_bought))}
                            </td>
                        </tr>
                        <tr>
                            <td className="border border-slate-800 px-1 py-1 text-center"></td>
                            <td className="border border-slate-800 px-1 py-1 text-center"></td>
                            <td className="border border-slate-800 px-1 py-1 underline">
                                المجموع
                            </td>
                            <td className="border border-slate-800 px-1 py-1 text-center">
                                {numberbeautify(show_million_format((Number(props?.data?.reduce((acc, item) => acc + parseFloat(item?.total_current_expense || 0), 0)))+(Number(props?.total_current_bought))+Number(props?.mizania?.filter((item)=>item?.mizania_category=="المصروفات الجارية")?.reduce((acc, item) => acc + parseFloat(item?.current_amount || 0), 0))))}
                            </td>
                            <td className="border border-slate-800 px-1 py-1 text-center">
                                {numberbeautify(show_million_format((Number(props?.data?.reduce((acc, item) => acc + parseFloat(item?.total_previous_expense || 0), 0)))+(Number(props?.total_previous_bought))+Number(props?.mizania?.filter((item)=>item?.mizania_category=="المصروفات الجارية")?.reduce((acc, item) => acc + parseFloat(item?.previous_amount || 0), 0))))}
                            </td>
                        </tr>
                        <tr>
                            <td className="border border-slate-800 px-1 py-1 text-center"></td>
                            <td className="border border-slate-800 px-1 py-1 text-center"></td>
                            <td className="border border-slate-800 px-1 py-1">
                                العمليات الجارية (المرحلة الاولي)
                            </td>
                            <td className="border border-slate-800 px-1 py-1 text-center">
                                {numberbeautify(show_million_format((Number(props?.total_current_sold))-Number((Number(props?.data?.reduce((acc, item) => acc + parseFloat(item?.total_current_expense || 0), 0)))+(Number(props?.total_current_bought))+Number(props?.mizania?.filter((item)=>item?.mizania_category=="المصروفات الجارية")?.reduce((acc, item) => acc + parseFloat(item?.current_amount || 0), 0)))))}
                            </td>
                            <td className="border border-slate-800 px-1 py-1 text-center">
                                {numberbeautify(show_million_format((Number(props?.total_previous_sold))-Number((Number(props?.data?.reduce((acc, item) => acc + parseFloat(item?.total_previous_expense || 0), 0)))+(Number(props?.total_previous_bought))+Number(props?.mizania?.filter((item)=>item?.mizania_category=="المصروفات الجارية")?.reduce((acc, item) => acc + parseFloat(item?.previous_amount || 0), 0)))))}
                            </td>
                        </tr>
                        <tr>
                            <td className="border border-slate-800 px-1 py-1 text-center">
                                
                            </td>
                            <td className="border border-slate-800 px-1 py-1 text-center">
                                
                            </td>
                            <td className="border border-slate-800 px-1 py-1 underline">
                                تضاف :الايرادات التحويلية الاخرى
                            </td>
                            <td className="border border-slate-800 px-1 py-1 text-center">

                            </td>
                            <td className="border border-slate-800 px-1 py-1 text-center">
                                
                            </td>
                        </tr>
                        {props?.mizania?.filter((item)=>item?.mizania_category=="تضاف :الايرادات التحويلية الاخرى")?.map((item, index)=>(
                            <tr key={index}>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {item?.mizania_statement_number}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {item?.mizania_directory_number}
                                </td>
                                <td className="border border-slate-800 px-1 py-1">
                                    {item?.mizania_name}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(show_million_format(item?.current_amount))}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(show_million_format(item?.previous_amount))}
                                </td>
                            </tr>
                        ))}

                        <tr>
                            <td className="border border-slate-800 px-1 py-1 text-center"></td>
                            <td className="border border-slate-800 px-1 py-1 text-center"></td>
                            <td className="border border-slate-800 px-1 py-1 underline">
                                المجموع
                            </td>
                            <td className="border border-slate-800 px-1 py-1 underline text-center">
                                {numberbeautify(show_million_format(Number(props?.mizania?.filter((item)=>item?.mizania_category=="تضاف :الايرادات التحويلية الاخرى")?.reduce((acc, item) => acc + parseFloat(item?.current_amount || 0), 0))))}
                            </td>
                            <td className="border border-slate-800 px-1 py-1 underline text-center">
                                {numberbeautify(show_million_format(Number(props?.mizania?.filter((item)=>item?.mizania_category=="تضاف :الايرادات التحويلية الاخرى")?.reduce((acc, item) => acc + parseFloat(item?.previous_amount || 0), 0))))}
                            </td>
                        </tr>
                        <tr>
                            <td className="border border-slate-800 px-1 py-1 text-center"></td>
                            <td className="border border-slate-800 px-1 py-1 text-center"></td>
                            <td className="border border-slate-800 px-1 py-1 underline">
                                تنزل ـ المصروفات الحويلية الاخرى
                            </td>
                            <td className="border border-slate-800 px-1 py-1 text-center"></td>
                            <td className="border border-slate-800 px-1 py-1 text-center"></td>
                        </tr>
                        {props?.mizania?.filter((item)=>item?.mizania_category=="تنزل ـ المصروفات التحويلية الاخرى")?.map((item, index)=>(
                            <tr key={index}>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {item?.mizania_statement_number}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {item?.mizania_directory_number}
                                </td>
                                <td className="border border-slate-800 px-1 py-1">
                                    {item?.mizania_name}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(show_million_format(item?.current_amount))}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(show_million_format(item?.previous_amount))}
                                </td>
                            </tr>
                        ))}
                        <tr>
                            <td className="border border-slate-800 px-1 py-1 text-center"></td>
                            <td className="border border-slate-800 px-1 py-1 text-center"></td>
                            <td className="border border-slate-800 px-1 py-1 underline">
                                المجموع 
                            </td>
                            <td className="border border-slate-800 px-1 py-1 text-center">
                                {numberbeautify(show_million_format(Number(props?.mizania?.filter((item)=>item?.mizania_category=="تنزل ـ المصروفات التحويلية الاخرى")?.reduce((acc, item) => acc + parseFloat(item?.current_amount || 0), 0))))}
                            </td>
                            <td className="border border-slate-800 px-1 py-1 text-center">
                                {numberbeautify(show_million_format(Number(props?.mizania?.filter((item)=>item?.mizania_category=="تنزل ـ المصروفات التحويلية الاخرى")?.reduce((acc, item) => acc + parseFloat(item?.previous_amount || 0), 0))))}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
});